import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { Dispatch } from 'redux';
import { all, call, takeEvery } from 'redux-saga/effects';
import LottieCache from './lottieCache';
import LottieController from './lottieController';
import LottieService from './lottieService';
import { LottieActions } from './slice';
import { ILottieLoadPayload } from './types';

export function* loadLottie(name: string) {
  //@ts-ignore
  let cachedValue = yield call([LottieCache, 'load'], name);
  if (!cachedValue) {
    const response: AxiosResponse = yield call([LottieService, 'loadLottie'], name);
    const data = response.data;
    yield call([LottieCache, 'save'], name, data);
    cachedValue = data;
  }
  return cachedValue;
}

export function* initLottieSaga(action: PayloadAction<string>) {
  yield call(LottieService.setAssetsUrl, action.payload);
  yield call(LottieCache.init);
}

export function* loadLottieSaga(action: PayloadAction<ILottieLoadPayload>) {
  const { name, autoplay, loop, dontKeep, id = name, stopOn } = action.payload;
  //@ts-ignore
  const cachedValue = yield call(loadLottie, name);
  yield call([LottieController, 'load'], id, cachedValue, autoplay, loop, dontKeep, stopOn);
}

export function* destroyLottieSaga(action: PayloadAction<string>) {
  yield call([LottieController, 'destroy'], action.payload);
}

export function* startLottieSaga(action: PayloadAction<string>) {
  yield call([LottieController, 'play'], action.payload);
}

export function* forceCacheLottieSaga(action: PayloadAction<string>) {
  yield call(loadLottie, action.payload);
}

export default function* watchLottie(dispatch: Dispatch) {
  // initialize controller with dispatch function
  LottieController.setup(dispatch);
  // start watching for actions
  yield all([
    takeEvery(LottieActions.initLottie.type, initLottieSaga),
    takeEvery(LottieActions.lottieLoad.type, loadLottieSaga),
    takeEvery(LottieActions.lottieDestroy.type, destroyLottieSaga),
    takeEvery(LottieActions.lottieStart.type, startLottieSaga),
    takeEvery(LottieActions.lottieForceCache.type, forceCacheLottieSaga),
  ]);
}
